export function getProducts() {

  const rootElement = document.getElementById("root");
  const loader = document.getElementById("loading");

  // if (loader) {
  //   loader.style.opacity = 0;
  // }

  let page = 1;
  let hasMore = true;

  let locale = rootElement.dataset.locale;
  let host = rootElement.dataset.host;
  let endpoint = rootElement.dataset.endpoint;

  const getItems = async (page) => {
    setTimeout(async () => {
      try {
        const API_URL = `${host+endpoint}=${page}`;
        const response = await fetch(API_URL);
        const results = await response.json();

        showItem(results.data);

        const dataLength = results.data.length;

        if (dataLength === 0 || dataLength < 24) {
          hasMore = false;
        }
      } catch (error) {
        console.log(error.message);
      } finally {
      }
    }, 0);
  };

  const showItem = (items) => {
    items.forEach((item, index) => {
      const itemEl = document.createElement("div");
      itemEl.classList.add("highlights__item");
      // itemEl.setAttribute("data-aos", "fade-up");
      // <img src="${item.image}" alt="alt" title="title" />
      const url = "tr" === locale ? "/urunler" : "/products";
      itemEl.innerHTML = `
<div class="highlights__box" data-aos="fade">
  <a class="product-link ${item.attributes.isNew ? "new-product" : ""}" href="${url}/${item.id}/${item.attributes.slug}">
    <img class="product-img" src="${host + item.attributes.photos.data[0].attributes.url}" alt="${item.attributes.name}" title="${item.attributes.name}" />
  </a>
  <p class="product-code">${item.attributes.name}</p>
</div>`;
      rootElement.appendChild(itemEl);
    });
  };


  var paginationBtn = document.getElementById("pagination-btn");
  paginationBtn.addEventListener(
      "click",
      morePage,

      false
  );

  function morePage(e) {
    e.preventDefault();
    e.stopPropagation();
    if (hasMore) {
      page++;
      getItems(page);

      // loader.style.opacity = 1;
    } else {
      loader.style.opacity = 1;
      loader.innerHTML = "Gösterilecek başka ürün yok.";
    }
  }

  setTimeout(() => {
    getItems(1);
  }, 10);
}